import React, { memo, ReactNode } from 'react';
import { PageInfo } from '@lgg/isomorphic/types/__generated__/graphql';
import { PaginationInfo } from 'src/components/general/display/pagination-info';
import { TablePagination } from 'src/components/general/display/table-pagination';
import { TableLayoutHeader } from 'src/components/general/table-helpers';
import { PageContainer } from 'src/components/layout/page-containers';

type AiAgentsListLayoutProps = {
  testId: string;
  totalCount: number;
  entityName: string;
  pageInfo: PageInfo;
  onNextPage: (params: { endCursor: string }) => void;
  onPreviousPage: (params: { startCursor: string }) => void;
  actions?: JSX.Element;
  children: ReactNode;
};

export const AiAgentsListLayout = memo<AiAgentsListLayoutProps>(
  ({
    testId,
    totalCount,
    entityName,
    pageInfo,
    onNextPage,
    onPreviousPage,
    actions = <></>,
    children,
  }) => {
    const { hasPreviousPage, hasNextPage, startCursor, endCursor } = pageInfo;

    return (
      <PageContainer data-lgg-id={`${testId}-container`}>
        <TableLayoutHeader
          leftContent={
            <PaginationInfo
              total={totalCount}
              testId={`${testId}-pagination-info`}
              entityName={entityName}
            />
          }
          rightContent={actions}
        />
        {children}
        <TablePagination
          hasPreviousPage={hasPreviousPage}
          hasNextPage={hasNextPage}
          onLoadPreviousPage={() => {
            if (hasPreviousPage && startCursor) {
              onPreviousPage({ startCursor });
            }
          }}
          onLoadNextPage={() => {
            if (hasNextPage && endCursor) {
              onNextPage({ endCursor });
            }
          }}
        />
      </PageContainer>
    );
  },
);
